// components
import { Portal } from '@mui/material';
import {
  StyledFloatingToolbarContainer,
  StyledHotZoneBox,
  StyledZenPortalContainerBox
} from './ZenPortal.styles';

// types
import { ZenPortalProps } from './ZenPortal.types';

export function ZenPortal({
  hotzoneWidth,
  open,
  onEnter,
  onLeave,
  anchor,
  children
}: ZenPortalProps) {
  return (
    <Portal>
      <StyledZenPortalContainerBox>
        {/* Right-edge hotzone */}
        <StyledHotZoneBox
          aria-hidden
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
          onTouchStart={onEnter}
          hotzoneWidth={hotzoneWidth}
        />

        {/* Floating toolbar container */}
        <StyledFloatingToolbarContainer
          onMouseEnter={onEnter}
          onMouseLeave={onLeave}
          open={open}
          anchor={anchor}
        >
          {children}
        </StyledFloatingToolbarContainer>
      </StyledZenPortalContainerBox>
    </Portal>
  );
}
